// 年底信息
<template>
  <div>
    <!-- <Header/> -->
    <Logo></Logo>
    <div><img :src="image" class="bg"></div>
    <div class="box">
        <div class="dropdown">
            <el-dropdown @command='handleSelectName' placement="left-start">
            <span class="el-dropdown-link">
                {{this.selectup}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <div>
                <el-dropdown-menu slot="dropdown" trigger='click'>
                        <div v-for="(list,i) in lists">
                            <!-- command绑定i来判断是哪一个下拉 -->
                            <el-dropdown-item :command=i>
                                {{list}}
                            </el-dropdown-item>
                        </div>
                </el-dropdown-menu>
            </div>
</el-dropdown>
        </div>
    <div>
  <el-table :data="tableData1" stripe class="table">
    <el-table-column prop="name" label="利润表摘要"></el-table-column>
    <el-table-column prop="sub"  :label=selectup align="right"></el-table-column>
  </el-table>
  <el-table :data="tableData2" stripe class="table">
    <el-table-column prop="name" label="资产负债表摘要"></el-table-column>
    <el-table-column prop="sub"  :label=selectup align="right"></el-table-column>
  </el-table>
    <el-table :data="tableData3" stripe class="table">
    <el-table-column prop="name" label="现金流量表摘要"></el-table-column>
    <el-table-column prop="sub"  :label=selectup align="right"></el-table-column>
  </el-table>
    </div>
    </div>
  </div>
</template>

<script>
// import Header from '../../common/FirstHeader.vue'
import Logo from "../Index/Index_components/logo.vue"
import api from '@/utils/api'
export default {
  name: 'Year',
  data () {
    return {
      selectup: '',
      image: '',
      //   selectdown1: '2021',
      //   selectdown2: '2021',
      tableData1: [{
        name: '营业总收入(元)',
        sub: '',
      }, {
        name: '营业总成本(元)',
        sub: '',
      }, {
        name: '营业收入(元)',
        sub: '',
      }, {
        name: '营业利润(元)',
        sub: '',
      }, {
        name: '利润总额(元)',
        sub: '',
      }, {
        name: '净利润(元)',
        sub: '',
      }, {
        name: '归属母公司股东的净利润(元)',
        sub: '',
      }, {
        name: '非经常性损益(元)',
        sub: '',
      }, {
        name: '归属母公司股东的净利润(扣除非经常性损益)(元)',
        sub: '',
      },
      ],
      tableData2: [{
        name: '流动资产(元)',
        sub: '',
      }, {
        name: '固定资产(元)',
        sub: '',
      }, {
        name: '长期股权投资(元)',
        sub: '',
      }, {
        name: '资产总计(元)',
        sub: '',
      }, {
        name: '流动负债(元)',
        sub: '',
      }, {
        name: '非流动负债(元)',
        sub: '',
      }, {
        name: '负债合计(元)',
        sub: '',
      }, {
        name: '股东权益(元)',
        sub: '',
      }, {
        name: '归属母公司股东的权益(元)',
        sub: '',
      }, {
        name: '资本公积(元)',
        sub: '',
      }, {
        name: '盈余公积(元)',
        sub: '',
      }, {
        name: '未分配利润(元)',
        sub: '',
      },
      ],
      tableData3: [{
        name: '经营活动产生现金净流量(元)',
        sub: '',
      }, {
        name: '投资活动产生现金净流量(元)',
        sub: '',
      }, {
        name: '筹资活动产生现金净流量(元)',
        sub: '',
      }, {
        name: '现金及现金等价物净增加(元)',
        sub: '',
      },],
      list: [],
      lists: [],
      lists1: []
    }
  },
  components: {
    // Header,
    Logo,
  },
  created () {
    if (window.localStorage.getItem('investor')) {
      var image1 = JSON.parse(window.localStorage.getItem('investor'))
      this.image = image1.data.data.image
    }
    this.getYear()
  },
  methods: {
    async getYear () {
      const { data: data } = await api.getFinance(0)
      if (data.code === 200) {
        console.log('我是年度财务报表', data)
        this.list = data.data
        this.list.forEach(item => {
          this.lists.push(item.REPORTDATESTR)
        })
        this.changeData(0)
        this.selectup = this.lists[0]
        // console.log(this.selectup)

      }
    },
    changeData (command) {
      this.tableData1[0].sub = this.list[command].TOTALOPERATEREVE
      this.tableData1[1].sub = this.list[command].TOTALOPERATEEXP
      this.tableData1[2].sub = this.list[command].STR_OPERATEREVE
      this.tableData1[3].sub = this.list[command].OPERATEPROFIT
      this.tableData1[4].sub = this.list[command].SUMPROFIT
      this.tableData1[5].sub = this.list[command].NETPROFIT
      this.tableData1[6].sub = this.list[command].PARENTNETPROFIT
      this.tableData1[7].sub = this.list[command].FJCXSY
      this.tableData1[8].sub = this.list[command].CUTPARENTNETPROFIT

      this.tableData2[0].sub = this.list[command].SUMLASSET
      this.tableData2[1].sub = this.list[command].FIXEDASSET
      this.tableData2[2].sub = this.list[command].LTEQUITYINV
      this.tableData2[3].sub = this.list[command].SUMASSET
      this.tableData2[4].sub = this.list[command].SUMLLIAB
      this.tableData2[5].sub = this.list[command].SUMNONLLIAB
      this.tableData2[6].sub = this.list[command].SUMLIAB
      this.tableData2[7].sub = this.list[command].SUMSHEQUITY
      this.tableData2[8].sub = this.list[command].SUMPARENTEQUITY
      this.tableData2[9].sub = this.list[command].CAPITALRESERVE
      this.tableData2[10].sub = this.list[command].SURPLUSRESERVE
      this.tableData2[11].sub = this.list[command].RETAINEDEARNING

      this.tableData3[0].sub = this.list[command].NETOPERATECASHFLOW
      this.tableData3[1].sub = this.list[command].NETINVCASHFLOW
      this.tableData3[2].sub = this.list[command].NETFINACASHFLOW
      this.tableData3[3].sub = this.list[command].NICASHEQUI
    },
    handleSelectName (command) {
      this.selectup = this.lists[command]
      this.changeData(command)
      //   this.selectdown1 = this.lists[command].part
      //   this.selectdown2 = this.lists[command].part
    }
  },
}
</script>
<style >
.el-dropdown-menu {
  left: auto !important;
  right: 0rem;
}
</style>
<style scoped>
.el-dropdown-menu {
  padding-bottom: 2rem;
}
/* 选择菜单设置 */
/deep/ .el-dropdown-menu__item {
  color: #333333 !important;
  font-size: 1.75rem;
  margin-top: 1.5rem;
}
/* 选择菜单位置定义 */
/deep/ .drop_menu {
  margin-top: 1.75rem !important;
  padding-bottom: 2rem !important;
  text-align: left;
}
/* table的内部样式 */
/deep/ .el-table--enable-row-transition .el-table__body td.el-table__cell {
  font-size: 1.5rem;
  color: #333333;
}
.dropdown {
  float: right;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  color: #333333;
  font-size: 1.75rem;
}
.bg {
  width: 46.875rem;
  height: 14.75rem;
}
.tabbar {
  margin-top: 24.125rem;
}
.box {
  width: 43.875rem;
  height: 30.875rem;
  margin-left: auto;
  margin-right: auto;
  margin-top: 4.625rem;
}
/* 标题背景设置 */
/deep/ .el-table th.el-table__cell {
  background-color: #f5f5f5;
  border-bottom-color: #015aaa !important;
  color: #015aaa;
  font-size: 1.75rem;
}
/* 斑马条纹颜色 */
/deep/
  .el-table--striped
  .el-table__body
  tr.el-table__row--striped
  td.el-table__cell {
  background: #f5f5f5;
}
/* 下拉菜单样式 */
.el-dropdown-link {
  cursor: pointer;
}
.el-dropdown {
  font-size: 1.75rem;
}
.el-icon-arrow-down {
  font-size: 1.75rem;
}
/* 表格样式 */
.table {
  /* display: flex */
}
</style>